module.exports = __webpack_public_path__ + "img/email-color.b4c666ce.svg";